export const EMPLOYEE_PORTAL_URL =
  process.env.REACT_APP_EMPLOYEE_PORTAL_URL || 'http://localhost:3001';

export const ADMIN_PORTAL_URL =
  process.env.REACT_APP_ADMIN_PORTAL_URL || 'http://localhost:3000';
